module.exports = __webpack_public_path__ + "assets/NoImgMobileMenu-8d95d5.svg";